import {Navigate, Route, Routes} from "react-router-dom";
import Layout from "./components/Layout";
import {HomePage} from "./pages/HomePage";
import React from "react";
import {useSetupInterceptors} from "./service/http.service";
import {UsersPage} from "./pages/UsersPage";
import {Route404} from "./pages/Route404";
import { PublicEditPage } from "./pages/PublicEditPage";
import Logout from "./pages/Logout";
import { ProfilePage } from "./pages/ProfilePage";
import { QuickLoginPage } from "./pages/QuickLoginPage";
import { SupportTickets } from "./pages/SupportTickets";
import {PasswordResetForm} from "./pages/PasswordResetForm";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import {TermsAndConditionsPage} from "./pages/TermsAndConditionsPage";
import {FeatureComparisonPage} from "./pages/FeaturesComparison";
import {SchedulerPage} from './pages/SchedulerPage';
import {ListingsPage} from "./pages/ListingsPage";


export function AppRoutes() {
    useSetupInterceptors();
    return <Routes>
        <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path={"/logout"} element={<Logout />} />
            <Route path={"/listings"} element={<ListingsPage />} />
            <Route path={"/listings/:id"} element={<ListingsPage />} />
            <Route path={"/prop/:id"} element={<ListingsPage />} />
            <Route path={"/profile"} element={<ProfilePage />} />
            <Route path={"/public-edit/:id"} element={<PublicEditPage />} />

            <Route path={"/users"} element={<UsersPage />} />
            <Route path={"/users/:id"} element={<UsersPage />} />
            <Route path={"/quick-logins"} element={<QuickLoginPage />} />
            <Route path={"/support"} element={<SupportTickets />} />
            <Route path={"/support/:id"} element={<SupportTickets />} />
            <Route path={"/password-reset/:id"} element={<PasswordResetForm />} />
            <Route path={"/privacy-policy"} element={<PrivacyPolicyPage />} />
            <Route path={"/terms-and-conditions"} element={<TermsAndConditionsPage />} />
            <Route path={"/features"} element={<FeatureComparisonPage />} />
            <Route path={"/scheduler"} element={<SchedulerPage />} />
            <Route path={"/city-analitics"} element={<Navigate to="/" replace />} />


            <Route path="*" element={<Route404 />} />
        </Route>
    </Routes>
}